import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useCustomerService} from '../hooks/useGetBasketPageSection';
import {CustomerServiceSkeleton} from './CustomerService.skeleton';
import {CustomerServiceView} from './CustomerServiceView';

export const CustomerService = () => {
  return (
    <DataFetcher
      request={useCustomerService()}
      Error={() => null}
      View={CustomerServiceView}
      Loading={CustomerServiceSkeleton}
    />
  );
};
